export const transform = ({questionsConsultant,version,...rest}) => {
  return {questionsConsultant,...rest}
}

export const decode = (obj) => {
  return {...obj,version:3}
}